
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen bg-cover bg-center bg-no-repeat flex items-center"
      style={{
        backgroundImage: `url('https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/7d35a61fb3fba114e4b2c293045d1be5.jpeg')`
      }}
    >
      <div className="absolute inset-0 bg-black/30"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight text-white">
            あなたの健康を<span className="text-[#3cb371]">全力でサポート</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto">
            患者様の健康を支える、元気と信頼を提供できる施術を目指して。
          </p>
        </div>
      </div>

      {/* Buttons positioned at top right */}
      <div className="absolute top-24 right-8 z-20 flex flex-col gap-4">
        <button className="bg-[#3cb371] hover:bg-[#2e8b57] text-white px-8 py-3 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer">
          ご予約はこちら
        </button>
        <button className="bg-white hover:bg-gray-50 text-[#3cb371] px-8 py-3 rounded-full font-semibold border border-[#3cb371] transition-colors whitespace-nowrap cursor-pointer">
          お電話でのご相談
        </button>
      </div>
    </section>
  );
}
